import React from 'react';
import styles from './Header.module.scss';
import {NavLink, useNavigate} from "react-router-dom";
import {Button} from "@mui/material";
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import {useBasicAuth} from "../../util/BasicAuth";

export default function Header() {
  const auth = useBasicAuth();
  const isLoggedIn = (localStorage.getItem("isAuthenticated") === "true");
  const navigate = useNavigate();

  // @ts-ignore
  return (
      <>
        <div className={styles['region-primary-menu']}>
          <div className={styles['block-system-branding-block']}>
            <a href="https://www.netzwerk-universitaetsmedizin.de/" rel="home" className={styles['site-logo']}>
              <img src={process.env.PUBLIC_URL + "/NUM-Logo-New.png"} alt="Startseite" />
            </a>
            <div className={styles['site-name']}>
              <a href="https://www.netzwerk-universitaetsmedizin.de/" rel="home">coverCHILD</a>
            </div>
          </div>
          <div className={styles["menu-right"]}>
            {isLoggedIn &&
                <Button onClick={() => auth?.logout()} startIcon={<LogoutIcon/>} variant="outlined">
                  Abmelden
                </Button>
            }
          </div>
        </div>
      </>
  )
}
